<template>
  <div>
    <div class="container__table">
      <div class="admin-title_container">
        <h3>Administrador</h3>
      </div>
      <router-link to="/job-searches/new" class="button-newSearch">
        <i class="material-icons">person_add</i>{{$t("jobsearch.new")}}
      </router-link>

    <!-- Modal select filters -->
    <div class="modal__overlay" v-if="modalSelectFilters" @click.stop="modalSelectFilters=false">
      <div class="filters" v-if="modalSelectFilters" @click.stop="''">
        <div class="filters__close">
          <span>FILTRAR RESULTADOS</span>
          <i class="material-icons" @click.stop="modalSelectFilters=false">close</i>
        </div>
        <div class="filters__status-options">
          <div class="filters__status-options-title"><span>Estado</span></div>
          <div class="filters__status-options-row1">
            <div @click.stop="modelFilters.status = ''" :class="{'active': modelFilters.status == ''}">
              Activas
            </div>
            <div @click.stop="modelFilters.status = 'Published'" :class="{'active': modelFilters.status == 'Published'}">
              {{$t("jobsearch.detail.Published")}}
            </div>
            <div @click.stop="modelFilters.status = 'UnPublished'" :class="{'active': modelFilters.status == 'UnPublished'}">
              {{$t("jobsearch.detail.UnPublished")}}
            </div>
            <div @click.stop="modelFilters.status = 'Closed'" :class="{'active': modelFilters.status == 'Closed'}">
              {{$t("jobsearch.detail.Closed")}}
            </div>
          </div>
          <!--
          <div class="filters__status-options-row2">
            <div @click.stop="modelFilters.status = 'Pending'" :class="{'active': modelFilters.status == 'Pending'}">
              {{$t("jobsearch.detail.Pending")}}
            </div>
            <div @click.stop="modelFilters.status = 'RevisionPending'" :class="{'active': modelFilters.status == 'RevisionPending'}">
              {{$t("jobsearch.detail.RevisionPending")}}
            </div>
            <div @click.stop="modelFilters.status = 'Rejected'" :class="{'active': modelFilters.status == 'Rejected'}">
              {{$t("jobsearch.detail.Rejected")}}
            </div>
          </div>
          -->
        </div>
        <div class="filters__dates">
          <div class="filters__dates__close">
            <span>{{$t("jobsearch.detail.endDate")}}</span>
            <div class="filters__dates__close-from">
              <label>{{$t("jobsearch.filter.fromParam")}}</label>
              <input type="date" v-model="modelFilters.endDateFrom">
            </div>
            <div class="filters__dates__close-to">
              <label>{{$t("jobsearch.filter.toParam")}}</label>
              <input type="date" :min="modelFilters.endDateFrom" v-model="modelFilters.endDateTo">
            </div>
          </div>
          <div class="filters__dates__publish">
            <span>{{$t("jobsearch.tableheader.publishDate")}}</span>
            <div class="filters__dates__publish-from">
              <label>{{$t("jobsearch.filter.fromParam")}}</label>
              <input type="date" v-model="modelFilters.publishDateFrom">
            </div>
            <div class="filters__dates__publish-to">
              <label>{{$t("jobsearch.filter.toParam")}}</label>
              <input type="date" :min="modelFilters.publishDateFrom" v-model="modelFilters.publishDateTo">
            </div>
          </div>
        </div>
        <div class="filters__country_and_organization">
          <div class="filters__country">
            <span>{{$t("jobsearch.create.input_country")}}</span>
            <select v-model="modelFilters.countryId">
              <option disabled select value = "">{{$t("jobsearch.create.input_country")}}</option>
              <option v-for="c in countries" :key="c.id" :value="c.id">{{ c.name }}</option>
            </select>
          </div>
          <div class="filters__organization">
            <span>{{$t("jobsearch.create.input_organization")}}</span>
            <select v-model="modelFilters.organizationId">
              <option disabled select value = "">{{$t("jobsearch.create.input_organization")}}</option>
              <option v-for="o in organizations" :key="o.id" :value="o.id">{{ o.name }}</option>
            </select>
          </div>
        </div>  
        <div class="filters__buttons">
          <button class="filters__buttons-clear" @click.stop="clearFilters(); modalSelectFilters=false">{{$t("jobsearch.filter.clear")}}</button>
          <button class="filters__buttons-apply" @click.stop="applyFilters(); modalSelectFilters = false;">{{$t("jobsearch.filter.apply")}}</button>
        </div>
      </div>
    </div> 

    <!-- Nav filters -->
    <div class="search-nav">
        <div class="search-nav__search-field">
          <span><i class="material-icons">search</i></span>
          <input type="search" v-model="modelFilters.filter" placeholder="Buscar por título" @keydown.enter="applyFilters()">
        </div>
        <div class="search-nav__filter">
          <button @click.stop="modalSelectFilters=true;">
            <span>{{$t("jobsearch.filter.action")}}</span>
            <i class="material-icons">filter_list</i> 
          </button>
        </div>
    </div>

    <div class="filters-actives">
      <div v-if="filterActive!=''">{{filterActive}} <i class="material-icons" @click.stop="modelFilters.filter=''; applyFilters();">close</i></div>
      <div v-if="modelFiltersActives.status!=''">{{ $t(`jobsearch.detail.${modelFiltersActives.status}`) }} <i class="material-icons" @click.stop="modelFilters.status=''; applyFilters();">close</i></div>
      <div v-if="modelFiltersActives.publishDateFrom !='' || modelFiltersActives.publishDateTo !=''">
        {{$t(`jobsearch.detail.Published`)}} 
        <span v-if="modelFiltersActives.publishDateFrom !=''">desde: {{formatDate(modelFiltersActives.publishDateFrom)}} </span>
        <span v-if="modelFiltersActives.publishDateTo !=''">hasta: {{formatDate(modelFiltersActives.publishDateTo)}}</span>
        <i class="material-icons" @click.stop="modelFilters.publishDateFrom='';modelFilters.publishDateTo=''; applyFilters();">close</i>
      </div>
      <div v-if="modelFiltersActives.endDateFrom !='' || modelFiltersActives.endDateTo !=''">
        {{$t(`jobsearch.detail.Closed`)}} 
        <span v-if="modelFiltersActives.endDateFrom !=''">desde: {{formatDate(modelFiltersActives.endDateFrom)}} </span>
        <span v-if="modelFiltersActives.endDateTo !=''">hasta: {{formatDate(modelFiltersActives.endDateTo)}}</span>
        <i class="material-icons" @click.stop="modelFilters.endDateFrom='';modelFilters.endDateTo=''; applyFilters();">close</i>
      </div>
      <div v-if="modelFiltersActives.organizationId != ''">
        <span>Empresa: {{getOrganizationNameById(modelFiltersActives.organizationId)}}</span>
        <i class="material-icons" @click.stop="modelFilters.organizationId=''; applyFilters();">close</i>
      </div>
      <div v-if="modelFiltersActives.countryId != ''">
        <span>País: {{getCountryNameById(modelFiltersActives.countryId)}}</span>
        <i class="material-icons" @click.stop="modelFilters.countryId=''; applyFilters();">close</i>
      </div>
    </div> 

      <div class="new-search">
        <div class="table-container" id="scrollRoot">
          <table>
            <thead>
              <tr>
                <th class="th__order">
                  <span>{{$t("jobsearch.tableheader.title")}}</span> 
                  <div class="orderBy" @click.stop="orderByTitle()">
                    <i :class="{'material-icons':true, 'orderBy--active': orderBy=='titleAsc'}">arrow_drop_up</i>
                    <i :class="{'material-icons':true, 'orderBy--active': orderBy=='titleDesc'}">arrow_drop_down</i>
                  </div> 
                </th>
                <th class="th__order">
                  <span>{{$t("jobsearch.create.input_country")}}</span> 
                  <div class="orderBy" @click.stop="orderByCountry()">
                    <i :class="{'material-icons':true, 'orderBy--active': orderBy=='countryAsc'}">arrow_drop_up</i>
                    <i :class="{'material-icons':true, 'orderBy--active': orderBy=='countryDesc'}">arrow_drop_down</i>
                  </div> 
                </th>
                <th class="th__order">
                  <span>{{$t("jobsearch.create.input_organization")}}</span> 
                  <div class="orderBy" @click.stop="orderByOrganization()">
                    <i :class="{'material-icons':true, 'orderBy--active': orderBy=='organizationAsc'}">arrow_drop_up</i>
                    <i :class="{'material-icons':true, 'orderBy--active': orderBy=='organizationDesc'}">arrow_drop_down</i>
                  </div> 
                </th>               
                <th class="th__order">
                  <span>{{$t("jobsearch.tableheader.publishDate")}}</span>
                  <div class="orderBy" @click.stop="orderByPublishDate()">
                    <i :class="{'material-icons':true, 'orderBy--active': orderBy=='publishDateAsc'}">arrow_drop_up</i>
                    <i :class="{'material-icons':true, 'orderBy--active': orderBy=='publishDateDesc'}">arrow_drop_down</i>
                  </div> 
                </th>
                <th class="th__order">
                  <span>{{$t("jobsearch.tableheader.endDate")}}</span>                
                  <div class="orderBy" @click.stop="orderByEndDate()">
                    <i :class="{'material-icons':true, 'orderBy--active': orderBy=='endDateAsc'}">arrow_drop_up</i>
                    <i :class="{'material-icons':true, 'orderBy--active': orderBy=='endDateDesc'}">arrow_drop_down</i>
                  </div> 
                </th> 
                <th>{{ $t("jobsearch.tableheader.applied") }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="jobSearchActivesReady">
                <tr v-for="jsa in jobSearchActives" :key="jsa.id">
                  <td class="table-container__title">
                    {{ jsa.title }}
                    <div v-if="jsa.status == 'Publicada'" class="table-container__title__status" :class="`table-container__title__status--${ jsa.status }`">{{ $t(`jobsearch.detail.${jsa.status}`) }}</div>
                    <div v-else class="table-container__title__status" :class="`table-container__title__status--${ jsa.status }`">{{ jsa.status }}</div>
                  </td>
                  <td>{{ jsa.country }}</td>
                  <td>{{ jsa.organization }}</td>
                  <td>{{ formatDate(jsa.publishDate) }}</td>
                  <td>{{ formatDate(jsa.endDate) }}</td>
                  <td>{{ jsa.numberOfApplies }}</td>
                  <td class="table-container__actions">
                    <Tooltip text="Editar" icon="edit" @click.stop="openJobSearch(jsa.id)"/>
                    <Tooltip text="Clonar" icon="copy_all" @click.stop="openCloneJobSearch(jsa.id)"/>
                    <Tooltip text="Ver" icon="visibility"  @click.stop="openJobSearchApplies(jsa.id)"/>
                  </td>
                </tr>
                
              </template>
              <tr v-else v-for="index in 3" :key="index">
                  <td><Skeletor width="100%" height="24"/></td>
                  <td><Skeletor width="100%" height="24"/></td>
                  <td><Skeletor width="100%" height="24"/></td>
                  <td><Skeletor width="100%" height="24"/></td>
                  <td><Skeletor width="100%" height="24"/></td>
                  <td><Skeletor width="100%" height="24"/></td>
              </tr>
            </tbody>
          </table>
          <div id="endDiv" v-if="jobSearchActivesReady"></div>
        </div>
      </div>

    </div>
  </div>
</template> 
<script>
import { useStore } from 'vuex';
import { onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import moment from 'moment';
import { useI18n } from 'vue-i18n';
import { Skeletor } from 'vue-skeletor';
import Tooltip from '@/components/Common/Tooltip.vue';


export default {
  components:{
    Skeletor,
    Tooltip,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const jobSearchActives = ref([]);
    const { t } = useI18n();
    const jobSearchActivesReady = ref(false);
    const countries = ref([]);
    const organizations = ref([]);
    const remainResults = ref();
    const rows = ref(20);
    const page = ref(0);

    /* FILTROS */
    const modelFilters = ref({
      filter: '',
      status: '',
      publishDateFrom: '',
      publishDateTo: '',
      endDateFrom: '',
      endDateTo: '',
      pageNumber: page.value,
      rowsPerPage: rows.value,
      countryId: '',
      organizationId: '',
      orderBy: 'title',
      sortBy: 'asc'
    });
    let modelFiltersActives = ref({
      filter: '',
      status: '',
      publishDateFrom: '',
      publishDateTo: '',
      endDateFrom: '',
      endDateTo: '',
      pageNumber: page.value,
      rowsPerPage: rows.value,
      countryId: '',
      organizationId: '',
      orderBy: 'title',
      sortBy: 'asc'
    });
    let filterActive = ref('');
    const modalSelectFilters = ref(false);
    const orderBy = ref('titleAsc');
    async function applyFilters(){
      jobSearchActivesReady.value=false;
      try {
        switch(orderBy.value){
          case 'publishDateDesc':
            modelFilters.value.orderBy = 'publishDate'
            modelFilters.value.sortBy = 'desc'
            break;
          case 'publishDateAsc':
            modelFilters.value.orderBy = 'publishDate'
            modelFilters.value.sortBy = 'asc'
            break;
            case 'endDateDesc':
              modelFilters.value.orderBy = 'endDate'
              modelFilters.value.sortBy = 'desc'
              break;
          case 'endDateAsc':
            modelFilters.value.orderBy = 'endDate'
            modelFilters.value.sortBy = 'asc'
            break;
          case 'titleDesc':
            modelFilters.value.orderBy = 'title'
            modelFilters.value.sortBy = 'desc'
            break;
          case 'titleAsc':
            modelFilters.value.orderBy = 'title'
            modelFilters.value.sortBy = 'asc'
            break;
          case 'countryAsc':
            modelFilters.value.orderBy = 'country'
            modelFilters.value.sortBy = 'asc'
            break;
          case 'countryDesc':
            modelFilters.value.orderBy = 'country'
            modelFilters.value.sortBy = 'desc'
            break;
          case 'organizationAsc':
            modelFilters.value.orderBy = 'organization'
            modelFilters.value.sortBy = 'asc'
            break;
          case 'organizationDesc':
            modelFilters.value.orderBy = 'organization'
            modelFilters.value.sortBy = 'desc'
            break;
        }
        /* const response =  await store.dispatch('organization_jobSearch_searchFilters',modelFilters.value);
        jobSearchActives.value = response.data; */
        page.value = 0;
        jobSearchActives.value = [];
        getJobsData();
        modelFiltersActives.value = JSON.parse(JSON.stringify(modelFilters.value));
        filterActive.value = JSON.parse(JSON.stringify(modelFilters.value.filter));
        jobSearchActivesReady.value=true;
      } catch (e) {
        store.dispatch('notifications_create', { text: t(`notifications.generic`) });
      }
    }
    function clearFilters(){
      modelFilters.value = {
        filter: '',
        status: '',
        publishDateFrom: '',
        publishDateTo: '',
        endDateFrom: '',
        endDateTo: '',
        pageNumber: page.value,
        rowsPerPage: rows.value,
        countryId: '',
        organizationId: '',
        orderBy: 'title',
        sortBy: 'asc'
      };
      filterActive.value = '';
      modelFiltersActives.value = modelFilters.value;
      applyFilters()
    }
    watch(modalSelectFilters, ()=>{
      if(modalSelectFilters.value){
        modelFilters.value = JSON.parse(JSON.stringify(modelFiltersActives.value));
      }
    })

    function orderByPublishDate(){
      if(orderBy.value != 'publishDateDesc') orderBy.value = 'publishDateDesc';
      else orderBy.value = 'publishDateAsc';
      applyFilters()
    }

    function orderByEndDate(){
      if(orderBy.value != 'endDateDesc') orderBy.value = 'endDateDesc';
      else orderBy.value = 'endDateAsc';
      applyFilters()
    }

    function orderByTitle(){
      if(orderBy.value != 'titleAsc') orderBy.value = 'titleAsc';
      else orderBy.value = 'titleDesc';
      applyFilters()
    }

    function orderByCountry(){
      if (orderBy.value != 'countryAsc') orderBy.value = 'countryAsc';
      else orderBy.value = 'countryDesc';
      applyFilters();
    }

    function orderByOrganization(){
      if (orderBy.value != 'organizationAsc') orderBy.value = 'organizationAsc';
      else orderBy.value = 'organizationDesc';
      applyFilters();
    }

    function getOrganizationNameById(id){
        return organizations.value.find(o => o.id == id).name;
    }

    function getCountryNameById(id){
      return countries.value.find(c => c.id == id).name;
    }
/* FIN FILTROS */
    let options;
    let observer;
    let target; 

    async function getJobsData(){
      //const jobSearches =  await store.dispatch('organization_jobSearch_search', { orderBy:'publishDate', sortBy:'asc', filter: '', pageNumber: page.value, rowsPerPage: rows.value });
      modelFilters.value.pageNumber = page.value;
      const jobSearches =  await store.dispatch('organization_jobSearch_searchFilters', modelFilters.value);
      remainResults.value = jobSearches.totalResults - (rows.value * (page.value+1));
      jobSearchActives.value.push(...jobSearches.data);
      jobSearchActivesReady.value = true;
    }

    onMounted(async () => {
      try {
        await getJobsData()
        const countriesReq = await store.dispatch('stuff_getCountries');
        const organizationsReq = await store.dispatch('stuff_getOrganizations');
        countries.value = countriesReq;   
        organizations.value = organizationsReq;

        options = {
          root: document.querySelector('#scrollRoot'),
          rootMargin: '0px',
          threshold: 1.0
        }
       
        setTimeout(async()=>{ 
          target = document.querySelector('#endDiv');
          observer = new IntersectionObserver((entries)=>{
            if(entries[0].isIntersecting) pagination();
          }, options);  
          observer.observe(target); 
        },0)

      } catch (e) {
        store.dispatch('notifications_create', { text: t(`notifications.generic`) });
      }
    });
        
    async function pagination(){
      if(remainResults.value > 0){
        page.value++;
        await getJobsData();
      }
    }

    function openJobSearch (jobSearchID) {
      router.push(`/job-searches/edit/${jobSearchID}`);
    }

    function openCloneJobSearch (jobSearchID) {
      router.push(`/job-searches/clone/${jobSearchID}`);
    }

    function openJobSearchApplies (jobSearchID) {
      router.push(`/job-searches/${jobSearchID}/applies`);
    }

    function formatDate(dateTime) {
        return moment(dateTime).isValid() ? moment(dateTime).format("DD/MM/YYYY") : "";
    }
    
    return {
      jobSearchActives,
      jobSearchActivesReady,
      openJobSearch,
      openCloneJobSearch,
      openJobSearchApplies,
      formatDate,
      applyFilters,
      clearFilters,
      modelFilters,
      modelFiltersActives,
      filterActive,
      modalSelectFilters,
      orderBy,
      orderByPublishDate,
      orderByEndDate,
      orderByTitle,
      orderByCountry,
      orderByOrganization,
      countries,
      organizations,
      getOrganizationNameById,
      getCountryNameById,
      pagination,
    }
  }
}
</script>

<style lang="scss" scoped>  
  @import '~vue-skeletor/dist/vue-skeletor.css';

  .main-container {
    display: flex;
    justify-content: center;
  }

  .container__table{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .admin-title_container{
      width: 100%;
      //max-width: 1500px;
      text-align: left;
      h3{
        color: $orange;
      }
    }
  }

  .new-search {
    margin-top: 16px;

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      i {
        font-size: 32px;
        color: $lightgreen;
      }
    }
    .table-container{
        width: 100%;
        .th__order{
          display: inline-flex;
          align-items: center;
          justify-content:center;
          &:first-child{
            justify-content: flex-start;
          }
        }
        tr{
          grid-template-columns: repeat(7, minmax(180px, 1fr));
        }    
    }

    p {
      text-shadow: none;
      font-family: $font-opensans;
      color: $gray;
      font-weight: 400;
      @include font-settings(base,base);
      margin-bottom: $margin-base;
    }

    .table-container__title {
      text-align: left;

      &__status {
        @include font-settings(milli,base);
        color: $gray;
        display: flex;
        gap: 4px;
        margin-top: $margin-milli;

        &:before {
          content: '';
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: $gray;
        }

        &--Publicada {
          color: $lightgreen;

          &:before {
            background: $lightgreen;
          }
        }

        &--Cerrada {
          color: tomato;

          &:before {
            background: tomato;
          }
        }
      }
    }
    .table-container__actions{
      border-left: 2px solid $orange;
    }
  }

  .orderBy{
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    i{
      line-height: 8px;
      color: $lightgray !important;
      cursor: pointer;
    &.orderBy--active{
      color: $orange !important;
    }
    }
  }

  .button-newSearch {
  padding: $margin-milli $margin-kilo $margin-milli $margin-base;
  position: fixed;
  right: 16px;
  bottom: 16px;
  background: $orange;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $white;
  z-index: 14;
  font-family: Palanquin Dark;
  font-weight: 600;
  i{
    margin-right: $margin-milli;
    color: #fff !important;
  }
  &:hover{
    opacity: 1;
  }
}



.material-icons{
  color: $orange;
}

.filters{
  position: relative;
  width: 100%;
  max-width: 490px;
  height: fit-content;
  min-height: 326px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  z-index: 500;
  div{
    width: 100%;
  }
  &__close{
    padding-bottom: 12px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    span{
      color: $orange;
      font-family: $font-palanquin;
      font-size: 18px;
      font-weight: bold;
    }
    i{
      color: #303030;
      cursor: pointer;
    }
  }
  &__status-options{
    padding-bottom: 8px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    div{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      div{
        width: fit-content;
        padding: 2px 12px;
        font-family: Palanquin Dark;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        color: $mediumgray;
        text-transform: uppercase;
        border: 1px solid $mediumgray;
        border-radius: 16px;
        cursor: pointer;
        &.active{
          background-color: $mediumgray;
          color: #fff;
        }
      }
    }
    &-title{
      span{
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 23px;
        color: $gray;
      }
    }
  }
  &__dates{
    padding: 16px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    div{
      width: fit-content;
      display: inline-flex;
      flex-direction: column;
      gap:4px;
      span{
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 23px;
        color: $mediumgray;
      }
      div{
        display: flex;
        flex-direction: column;
        gap: 0;
        label{
          font-size: 12px;
          font-family: Palanquin dark;
          line-height: 12px;
         
        }
        input{
          width: 200px;
          border: none;
          border-bottom: 2px solid $mediumgray;
          color: $gray;
          font-family: Palanquin Dark;
          line-height: 12px;
          color: $mediumgray;
          &:first-of-type{
            margin-bottom: 8px;
          }
        }
      }
    }
  }
  &__country_and_organization{
    padding-bottom: 16px;
    display:flex;
    justify-content: space-between;
    div{
      width: fit-content;
      display: inline-flex;
      flex-direction: column;
      gap:4px;
      span{
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 23px;
        color: $mediumgray;
      }
      select{
          width: 200px;
          border: none;
          border-bottom: 2px solid $mediumgray;
          color: $gray;
          font-family: Palanquin Dark;
          line-height: 12px;
          color: $mediumgray;
          &:first-of-type{
            margin-bottom: 8px;
          }
        }
    }   
  }
  &__buttons{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    &-clear{
      font-family: Palanquin Dark;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 25px;
      color: #9C9B9B;
    }
    &-apply{
      padding-bottom: 2px;
      width: 107px;
      height: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: $orange;
      border-radius: 50px;
      font-family: $font-palanquin;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 25px;
      color: #fff;
    }
  }
}

.search-nav{
  margin-bottom: 16px;
  width: 100%;
  margin-top: 32px;
  display: flex;
  flex-flow: row wrap-reverse;
  gap: 8px;
  &__search-field{
    width: 100%;
    max-width: 345px;
    display: flex;
    span{
      height: 40px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      color: #7d7d7d;
      border-color: #7D7D7D;
      border-style: solid;
      border-width: 1px 0 1px 1px;
      border-radius: 3px 0 0 3px;
      background-color: $lightergray;
    }
    input{
      width: 100%;
      height: 40px;
      border: none;
      border: 1px solid #7D7D7D;
      border-color: #7D7D7D;
      border-style: solid;
      border-width: 1px 1px 1px 0;
      border-radius: 0 3px 3px 0;
      background-color: $lightergray;
      &::placeholder {
        font-family: Open Sans;
        font-weight: bold;
        font-size: 16px;
        color: #7d7d7d;
      }
    }
  }
  &__filter{
    button{
      width: 137px;
      height: 40px;      
      padding: 0px 16px;      
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border: 1px solid $red;
      border-radius: 3px;
      background-color: $lightergray;
      span{
        font-family: Palanquin Dark;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 25px;
        color:$orange;
      }
      i{
        color:$orange;
      }
    }
  }
  &__toggle-view {
    height: 40px;
    display: inline-flex;
    align-items: stretch;
    background: #FFF;
    border: 1px solid $red;
    border-radius: 3px;
    div{
      width: 40px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      &:first-child {
        border-right: 1px solid $red;
      }
      i{
        color: #9C9B9B;
        cursor: pointer;
      }
    }
  }
  .activeView{
    color: $red;
  }
}

.filters-actives{
  display: flex;
  flex-flow: row wrap;
  gap: 8px;
  div{
    height: 32px;
    padding: 0 8px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border: 1px solid $red;
    border-radius: 210px;
    font-family: Palanquin Dark;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: $red;
    span{
      font-family: Palanquin Dark;
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      color: $red;
    }
    i{
      font-size: 20px;
      cursor: pointer;
    }
  }
}
/* #endDiv{
  height: 150px;
  background: blue;
} */
</style>